const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://359b9iouwd.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://d7k07hhpka.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://tgiowwjm51.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'master',
    HOSTNAME: 'https://locations.testing.recovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.recovery.forwoodsafety.com',
    WEBSOCKET: 'wss://jlmo7ui728.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;